/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Model SaaS API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateGroupRuleDto,
  GroupRuleDetailResponseDto,
  GroupRuleResponseDto,
  SetGroupRuleMembersDto,
  UpdateGroupRuleDto,
} from '.././model';

import { apiAxios } from '../../axios-instance';

export const adminGroupRulesControllerList = (signal?: AbortSignal) => {
  return apiAxios<GroupRuleResponseDto[]>({
    url: `/api/v1/admin/group-rules`,
    method: 'GET',
    signal,
  });
};

export const getAdminGroupRulesControllerListQueryKey = () => {
  return [`/api/v1/admin/group-rules`] as const;
};

export const getAdminGroupRulesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerList>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGroupRulesControllerListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGroupRulesControllerList>>> = ({
    signal,
  }) => adminGroupRulesControllerList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGroupRulesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGroupRulesControllerList>>
>;
export type AdminGroupRulesControllerListQueryError = unknown;

export function useAdminGroupRulesControllerList<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
          TError,
          Awaited<ReturnType<typeof adminGroupRulesControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGroupRulesControllerList<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
          TError,
          Awaited<ReturnType<typeof adminGroupRulesControllerList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGroupRulesControllerList<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminGroupRulesControllerList<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGroupRulesControllerListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminGroupRulesControllerCreate = (
  createGroupRuleDto: CreateGroupRuleDto,
  signal?: AbortSignal,
) => {
  return apiAxios<GroupRuleResponseDto>({
    url: `/api/v1/admin/group-rules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createGroupRuleDto,
    signal,
  });
};

export const getAdminGroupRulesControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGroupRulesControllerCreate>>,
    TError,
    { data: CreateGroupRuleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGroupRulesControllerCreate>>,
  TError,
  { data: CreateGroupRuleDto },
  TContext
> => {
  const mutationKey = ['adminGroupRulesControllerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGroupRulesControllerCreate>>,
    { data: CreateGroupRuleDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminGroupRulesControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGroupRulesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGroupRulesControllerCreate>>
>;
export type AdminGroupRulesControllerCreateMutationBody = CreateGroupRuleDto;
export type AdminGroupRulesControllerCreateMutationError = unknown;

export const useAdminGroupRulesControllerCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminGroupRulesControllerCreate>>,
      TError,
      { data: CreateGroupRuleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminGroupRulesControllerCreate>>,
  TError,
  { data: CreateGroupRuleDto },
  TContext
> => {
  const mutationOptions = getAdminGroupRulesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminGroupRulesControllerGetOne = (id: string, signal?: AbortSignal) => {
  return apiAxios<GroupRuleDetailResponseDto>({
    url: `/api/v1/admin/group-rules/${id}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGroupRulesControllerGetOneQueryKey = (id?: string) => {
  return [`/api/v1/admin/group-rules/${id}`] as const;
};

export const getAdminGroupRulesControllerGetOneQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGroupRulesControllerGetOneQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>> = ({
    signal,
  }) => adminGroupRulesControllerGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGroupRulesControllerGetOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>
>;
export type AdminGroupRulesControllerGetOneQueryError = unknown;

export function useAdminGroupRulesControllerGetOne<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGroupRulesControllerGetOne<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGroupRulesControllerGetOne<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminGroupRulesControllerGetOne<
  TData = Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGroupRulesControllerGetOne>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGroupRulesControllerGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminGroupRulesControllerUpdate = (
  id: string,
  updateGroupRuleDto: UpdateGroupRuleDto,
) => {
  return apiAxios<GroupRuleResponseDto>({
    url: `/api/v1/admin/group-rules/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateGroupRuleDto,
  });
};

export const getAdminGroupRulesControllerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGroupRulesControllerUpdate>>,
    TError,
    { id: string; data: UpdateGroupRuleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGroupRulesControllerUpdate>>,
  TError,
  { id: string; data: UpdateGroupRuleDto },
  TContext
> => {
  const mutationKey = ['adminGroupRulesControllerUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGroupRulesControllerUpdate>>,
    { id: string; data: UpdateGroupRuleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminGroupRulesControllerUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGroupRulesControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGroupRulesControllerUpdate>>
>;
export type AdminGroupRulesControllerUpdateMutationBody = UpdateGroupRuleDto;
export type AdminGroupRulesControllerUpdateMutationError = unknown;

export const useAdminGroupRulesControllerUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminGroupRulesControllerUpdate>>,
      TError,
      { id: string; data: UpdateGroupRuleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminGroupRulesControllerUpdate>>,
  TError,
  { id: string; data: UpdateGroupRuleDto },
  TContext
> => {
  const mutationOptions = getAdminGroupRulesControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminGroupRulesControllerRemove = (id: string) => {
  return apiAxios<void>({ url: `/api/v1/admin/group-rules/${id}`, method: 'DELETE' });
};

export const getAdminGroupRulesControllerRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGroupRulesControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGroupRulesControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminGroupRulesControllerRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGroupRulesControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminGroupRulesControllerRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGroupRulesControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGroupRulesControllerRemove>>
>;

export type AdminGroupRulesControllerRemoveMutationError = unknown;

export const useAdminGroupRulesControllerRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminGroupRulesControllerRemove>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminGroupRulesControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminGroupRulesControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminGroupRulesControllerSetMembers = (
  id: string,
  setGroupRuleMembersDto: SetGroupRuleMembersDto,
) => {
  return apiAxios<GroupRuleDetailResponseDto>({
    url: `/api/v1/admin/group-rules/${id}/members`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setGroupRuleMembersDto,
  });
};

export const getAdminGroupRulesControllerSetMembersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGroupRulesControllerSetMembers>>,
    TError,
    { id: string; data: SetGroupRuleMembersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGroupRulesControllerSetMembers>>,
  TError,
  { id: string; data: SetGroupRuleMembersDto },
  TContext
> => {
  const mutationKey = ['adminGroupRulesControllerSetMembers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGroupRulesControllerSetMembers>>,
    { id: string; data: SetGroupRuleMembersDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminGroupRulesControllerSetMembers(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGroupRulesControllerSetMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGroupRulesControllerSetMembers>>
>;
export type AdminGroupRulesControllerSetMembersMutationBody = SetGroupRuleMembersDto;
export type AdminGroupRulesControllerSetMembersMutationError = unknown;

export const useAdminGroupRulesControllerSetMembers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminGroupRulesControllerSetMembers>>,
      TError,
      { id: string; data: SetGroupRuleMembersDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminGroupRulesControllerSetMembers>>,
  TError,
  { id: string; data: SetGroupRuleMembersDto },
  TContext
> => {
  const mutationOptions = getAdminGroupRulesControllerSetMembersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
